import React, { useState, useEffect } from "react";
import axios from "../../utils/axiosInstance";
import Button from "../ui/Button";

const AddTaskFromRegistryModal = ({ bundleId, projectId, onClose, onSuccess }) => {
  const [tasks, setTasks] = useState([]);
  const [selectedTask, setSelectedTask] = useState(null);
  const [loading, setLoading] = useState(false);
  const [adding, setAdding] = useState(false);

  useEffect(() => {
    fetchTasks();
  }, []);

  // Lock body scroll when modal is open
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  const fetchTasks = async () => {
    setLoading(true);
    try {
      const res = await axios.get("/registry/tasks", {
        params: { status: "active", limit: 100 }
      });
      setTasks(res.data.items || []);
    } catch (error) {
      console.error("Error fetching tasks:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleAdd = async () => {
    if (!selectedTask) return;

    setAdding(true);
    try {
      await axios.post(`/task-bundles/${bundleId || "new"}/tasks/from-registry`, {
        taskId: selectedTask._id,
        ...(projectId ? { projectId } : {})
      });
      onSuccess && onSuccess();
    } catch (error) {
      console.error("Error adding task:", error);
      alert("Failed to add task");
    } finally {
      setAdding(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <h2 className="text-xl font-bold mb-4">Add Task from Registry</h2>

          {loading ? (
            <p className="text-gray-500">Loading tasks...</p>
          ) : tasks.length === 0 ? (
            <p className="text-gray-500">No tasks available in registry.</p>
          ) : (
            <div className="space-y-3 mb-6 max-h-96 overflow-y-auto">
              {tasks.map((task) => (
                <label
                  key={task._id}
                  className={`block p-4 border rounded cursor-pointer transition-colors ${
                    selectedTask?._id === task._id
                      ? 'border-blue-500 bg-blue-50'
                      : 'border-gray-200 hover:border-gray-300'
                  }`}
                >
                  <input
                    type="radio"
                    name="task"
                    value={task._id}
                    checked={selectedTask?._id === task._id}
                    onChange={() => setSelectedTask(task)}
                    className="mr-3"
                  />
                  <div className="inline-block">
                    <div className="font-medium">{task.name}</div>
                    <div className="text-sm text-gray-600">{task.description}</div>
                    <div className="text-xs text-gray-500 mt-1">
                      {task.subtaskRefs?.length || 0} subtask(s)
                    </div>
                  </div>
                </label>
              ))}
            </div>
          )}

          <div className="flex justify-end gap-2">
            <Button type="button" variant="outline" onClick={onClose}>
              Cancel
            </Button>
            <Button
              type="button"
              variant="solid"
              onClick={handleAdd}
              disabled={!selectedTask || adding}
            >
              {adding ? "Adding..." : "Add Task"}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddTaskFromRegistryModal;
